function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#E8ECFF",
  opacity: 0.408
}, /*#__PURE__*/React.createElement("path", {
  d: "M42.825 79.953c8.937 0 15.372.864 21.802-4.847 5.335-4.738 8.427-3.58 10.726-10.819C76.683 60.1 80 44.681 80 40c0-15.982-6.626-22.335-18.891-29.025C56.087 8.235 44.632 0 38.636 0c-6.83 0-15.934.125-21.443 3.616C10.758 7.694 4.097 16.22.837 23.563c-2.384 5.37 1.081 17.288 1.081 23.655 0 7.937 15.817 10.563 22.16 17.069 6.345 6.507 5.47 11.033 9.036 12.849 4.434 2.26.775 2.817 9.711 2.817z",
  transform: "translate(-644 -191) translate(301 40) translate(343 151)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-644 -191) translate(301 40) translate(343 151) translate(3 3)"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#428DFF",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 37,
  r: 36,
  fill: "#E8EDFC"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 22,
  r: 10,
  fill: "#A4C2F7"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A4C2F7",
  d: "M60 51.799c0-1.55-.207-3.057-.598-4.504C57.033 38.53 47.902 32 37 32c-10.854 0-19.952 6.472-22.37 15.178-.412 1.482-.63 3.03-.63 4.621 0 10.935 46 10.935 46 0z"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 59,
  r: 9,
  fill: "#E8EDFC",
  stroke: "#428DFF",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#428DFF",
  d: "M60 53c.552 0 1 .448 1 1v4h4c.552 0 1 .448 1 1s-.448 1-1 1h-4v4c0 .552-.448 1-1 1s-1-.448-1-1v-4h-4c-.552 0-1-.448-1-1s.448-1 1-1h4v-4c0-.552.448-1 1-1z"
})));

function SvgIconSignup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignup);
export default __webpack_public_path__ + "static/media/icon-signup.76dc0821.svg";
export { ForwardRef as ReactComponent };